import React from "react";
import { Selector } from "./selector";
import { Page } from "./page";
import { Barometer, PageType, SingularPage } from "../../../../types";
import { PageImage } from "./page-image";

interface PagesProps {
  onChangeIndex: (val: number) => void;
  active: SingularPage;
  barometer: Barometer;
}

export function Pages({ onChangeIndex, active, barometer }: PagesProps) {
  return (
    <div className="w-full mb-6">
      <Selector onChangeIndex={onChangeIndex} title={active.title} />
      <div className="flex flex-col sm:flex-row">
        <div className="sm:w-1/2">
          <PageImage currentPage={active} />
        </div>
        <p className="text-left sm:w-1/2 bg-gray p-5 break-words text-[13.5px]">
          {active.type === PageType.science && (
            <Page.VidenskabeligPublicering />
          )}
          {active.type === PageType.method && (
            <Page.UndersoegelsensMetode method={barometer.method} />
          )}
          {active.type === PageType.notes && (
            <Page.SærligeBemærkninger customComment={barometer.comment} />
          )}
          {active.type === PageType.evidence && <Page.SamletEvidens />}
        </p>
      </div>
    </div>
  );
}
